import type { RawComponent } from "../types.js";

function testLocalStorage(): boolean {
  try {
    const key = "__vs_probe__";
    localStorage.setItem(key, "1");
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

function testIndexedDb(): Promise<boolean> {
  return new Promise((resolve) => {
    try {
      if (!window.indexedDB) {
        resolve(false);
        return;
      }
      const request = indexedDB.open("__vs_probe__");
      request.onerror = () => resolve(false);
      request.onsuccess = () => {
        request.result.close();
        resolve(true);
      };
      setTimeout(() => resolve(false), 500);
    } catch {
      resolve(false);
    }
  });
}

export async function collectStorageComponents(): Promise<RawComponent[]> {
  const localStorageAvailable = testLocalStorage();
  const indexedDbAvailable = await testIndexedDb();
  return [
    { name: "localstorage_available", rawValue: String(localStorageAvailable) },
    { name: "indexeddb_available", rawValue: String(indexedDbAvailable) },
    { name: "cookie_support", rawValue: String(navigator.cookieEnabled) },
    { name: "storage_capability", rawValue: String(localStorageAvailable && indexedDbAvailable) },
  ];
}
